export const getAbsentScheduleState = (state: any) => state.absentSchedule
